"use client";
import { useRef, useState } from "react";

import ProductCard from "../ProductCard/ProductCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import { useSession } from "@/hooks/useSession";
const ForYou = ({ sticker, stickerBy, t }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [activeTab, setActiveTab] = useState(sticker?.[0]?.id || null);
  const { session } = useSession();

  return (
    <div className="forYou">
      <div className="subTitle">
        <span>{t["title.selected_for_you"]}</span>
        <div className="subButtons">
          {sticker?.map((item) => (
            // active className="active"
            <button
              type="button"
              key={item.id}
              className={activeTab === item.id ? "active" : ""}
              onClick={() => setActiveTab(item.id)}
            >
              {item.title}
            </button>
          ))}
        </div>
      </div>
      <div className="container">
        <button ref={prevRef} className="swiper-button-prev"></button>
        <button ref={nextRef} className="swiper-button-next"></button>
        {Object.keys(stickerBy).map((key) =>
          Number(key) === activeTab ? (
            <Swiper
              key={key}
              spaceBetween={20}
              slidesPerView={4}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              // onSwiper={(swiper) => {
              //   setTimeout(() => {
              //     swiper.params.navigation.prevEl = prevRef.current;
              //     swiper.params.navigation.nextEl = nextRef.current;
              //     swiper.navigation.init();
              //     swiper.navigation.update();
              //   });
              // }}
              modules={[Navigation]}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                640: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                991: {
                  slidesPerView: 4,
                },
              }}
            >
              {stickerBy[key]?.map((product) => (
                <SwiperSlide key={product.id}>
                  <ProductCard
                    item={product}
                    t={t}
                    isAuthenticated={!!session}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ForYou;
